// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/.store/css-loader@3.6.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".main .logo[data-v-18f13841]{padding-top:1.33333rem;text-align:center}.main .logo p[data-v-18f13841]{font-size:.37333rem}.main .btn[data-v-18f13841]{text-align:center;padding-top:5.33333rem}.main .btn p[data-v-18f13841]{font-size:.37333rem;color:#999}", ""]);
// Exports
module.exports = exports;
